<template>
  <div class="load-view">
    <div class="mdl-card__supporting-text mdl-card--expand" v-bind:class="{ blurred: state == 'working' }"
         v-if="(state == 'ready') || (state == 'working')">

      <div class="file-list-holder">
        <FileList v-bind:contentType="contentType" @selected="selected"></FileList>
      </div>

    </div>

    <div class="mdl-card__actions mdl-card--border" v-bind:class="{ blurred: state == 'working' }"
         v-if="state == 'ready' || state == 'working'">

      <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
              v-on:click="load" v-bind:disabled="!selectedFile">
        <i class="material-icons">cloud_download</i> {{ i18n().loadFromCloud }}
      </button>

      <span class="upload">
        <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          <i class="material-icons">file_upload</i> {{ i18n().upload }}
        </button>
        <input class="hidden-file" type="file" v-on:change="handleInputChange">
      </span>

    </div>
    <div class="working" v-if="state == 'working'">
      <div class="mdl-spinner mdl-js-spinner is-active"></div>
    </div>

    <div class="mdl-card__supporting-text mdl-card--expand done" v-if="state == 'done'">
      <p>{{ i18n().loaded(fileName) }}</p>
    </div>
    <div class="mdl-card__supporting-text mdl-card--expand error" v-if="state == 'error'">
      <p>{{ i18n().loadError(error) }}</p>
    </div>

    <div class="mdl-card__actions mdl-card--border" v-if="state == 'error' || state == 'done' ">
      <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
              v-on:click="close">
        <i class="material-icons">done</i>{{ i18n().ok }}
      </button>
    </div>

  </div>
</template>

<script>
  import FileList from "./FileList.vue"
  import api from "api"

  export default {
    name: 'load-view',
    props: {
      contentType: {
        type: String,
        default: function () {
          return "view"
        }
      },
      acceptedMime: {
        type: Array,
        default: function() {
          return null
        }
      },
      acceptedExtensions: {
        type: Array,
        default: function() {
          return ['sgf']
        }
      }
    },
    components: {
      FileList
    },
    data () {
      return {
        fileName: null,
        selectedFile: null,
        state: "ready",
        error: null,
        required: false
      }
    },
    methods: {
      i18n() { return i18n().save },
      handleInputChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        this.handleFileSelected(files[0])
      },
      handleFileSelected(file) {
        this.fileName = file.name
        const ext = file.name.split('.').pop()
        if(this.acceptedExtensions && this.acceptedExtensions.indexOf(ext) == -1)
          this.error = "File with extension "+ext+" is not supported"
        if(this.acceptedMime && file.type && this.acceptedMime.indexOf(file.type) == -1)
          this.error = "File type "+file.type+" is not supported"
        if(this.error) {
          this.state = 'error'
          return
        }
        this.state = 'working'
        var reader = new FileReader()
        reader.onload = (e) => {
          var data = e.target.result
          try {
            data = JSON.parse(data)
          } catch (e) {
            this.error = "Incompatible file format"
            this.state = 'error'
            return
          }
          this.state = 'done'
          this.$emit('load', data)
        }
        reader.readAsText(file)
      },
      load(e) {
        if(!this.selectedFile) {
          this.error = "no file selected"
          this.state = "error"
        }
        this.fileName = this.selectedFile.name
        this.state = 'working'

        api.get(["save", "content", this.contentType, this.selectedFile.name]).then(
          entry => {
            if(!entry) {
              this.state = "error"
              this.error = "notFound"
              return
            }
            this.state = "done"
            this.$emit('load', entry.content)
          }
        ).catch(
          error => {
            this.state = "error"
            this.error = error
          }
        )
      },
      close() {
        this.$emit('close')
      },
      selected(file) {
        this.selectedFile = file
      }

    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }
  }
</script>

<style scoped>
  .load-view {
    display: flex;
    flex-direction: column;
    min-height: 100px;
    position: relative;
  }

  .mdl-card__supporting-text {
    min-height: 60px;
  }

  .blurred {
    filter: blur(2px);
  }

  .mdl-textfield {
    width: 100%;
  }

  .mdl-card__actions > button,span {
    float: right;
    cursor: pointer;
  }
  .mdl-card__actions > span:hover {
    background: rgba(0,0,0, 0.07)
  }

  .working {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
  }
  .working div {
    margin: auto;
    height: 5em;
    width: 5em;
  }

  .done {
    display: flex;
    align-items: center;
  }
  .done p {
    font-size: 1.23em;
    text-align: center;
    margin: auto;
  }

  .error {
    color: darkred;
    display: flex;
    align-items: center;
  }
  .error p {
    font-size: 1.23em;
    text-align: center;
    margin: auto;
  }

  .upload {
    position: relative;
  }
  input.hidden-file {
    border: none;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom:0;
    width: 100%;
    height: 100%;
    pointer-events: all;
    cursor: pointer;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// LoadView.vue?cb6c0f96